import styles from "./Style.module.css";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import mainContext from "../../../context/mainContext";
import Button from "../../../components/Common/Button";
import UmooveApi from "../../../components/api/UmooveApi";

//TODO where to save the result ? its ment to be in local storage

// Creator : Team G - Orit F
function CalibrateCam() {
  const halfImgWidth = 51.5;
  const rightMargin = halfImgWidth - 30;
  const leftMargin = halfImgWidth + 30;

  const [posX, setPosX] = useState(
    localStorage.posX - halfImgWidth + 9 || window.innerWidth / 2 - halfImgWidth
  );
  const navigate = useNavigate();

  const {
    header: { setIsShowHeader },
  } = useContext(mainContext);

  const { initCam: { alreadiInit, setAlreadyInit } } = useContext(mainContext)
  function checkCameraPermission() {
    window.permissions.checkPermission(window.permissions.CAMERA, function (status) {
      if (!status.hasPermission) {
        requestCameraPermission();
      } else {
        setTimeout(() => {
          console.log("navigate from checkCameraPermission")
          navigate("/train-focus/start-focus");
        }, 100)
      }
    });
  }

  function requestCameraPermission() {
    window.permissions.requestPermission(window.permissions.CAMERA, function (status) {
      if (!status.hasPermission) {
        console.error('Camera permission not granted');
        alert("To ensure optimal functionality of the application, this permission is necessary.")
      } else {
        UmooveApi.API_stopUmoove().then(() => {
          setAlreadyInit(false)//so when you go forword in pages, the camera will init
          setTimeout(() => {
            console.log("navigate from requestCameraPermission")

            navigate("/train-focus/start-focus");
          }, 100)
        })
      }
    }, function () {
      console.error('Camera permission request denied');
    });
  }
  useEffect(() => {
    setIsShowHeader();

    if (localStorage.posX && localStorage.getItem("RoundNumber") == "0") {
      localStorage.setItem('RoundNumber', 1)
      window.cordovaOn ? checkCameraPermission() : navigate("/train-focus/start-focus");
    }
    return () => setIsShowHeader(true);
  }, []);

  const touch = (e) => {
    if (e.changedTouches[0].clientX <= 0) return setPosX(0 - rightMargin);
    else if (e.changedTouches[0].clientX >= window.innerWidth)
      return setPosX(window.innerWidth - leftMargin);
    else setPosX(e.changedTouches[0].clientX - halfImgWidth);
  };

  const touchEnd = (e) => {

    if (e.changedTouches[0].clientX <= 4) {
      return setPosX(0 - rightMargin);
    }

    if (e.changedTouches[0].clientX >= window.innerWidth - 4) {
      return setPosX(window.innerWidth - leftMargin);
    }
    setPosX(e.changedTouches[0].clientX - halfImgWidth);
  };

  const onClickBtn = () => {
    localStorage.posX = posX + halfImgWidth - 9;//51.5= img"moveDot"/2       9=half of the purple dot width
    console.log("send posX to DB. current posX=" + localStorage.posX);
    localStorage.setItem('RoundNumber', 1)
    window.cordovaOn ? checkCameraPermission() : navigate("/train-focus/start-focus");
  };

  return (
    <div className={styles["calibrateCam"]} style={window.buildType === "iPhone" ? { maxHeight: "90vh", height: "90vh", position: "relative" } : {}}>
      <div className={styles["arrowMove2"]}>
        <div
          className={styles["place"]}
          style={{ left: posX + "px" }}
          onTouchMove={(e) => touch(e)}
          onTouchEnd={(e) => touchEnd(e)}
          draggable="false"
        >
          <img
            className={styles["dragImg"]}
            src={require("./moveDot.png")}
            alt=""
          />
        </div>
      </div>

      <div className={styles["arrowMove"]}>
        <span>Slide the arrow left/right so that it points to your camera</span>
      </div>
      <button onClick={onClickBtn} className={styles["btnContinue"]} style={window.buildType === "iPhone" ? { bottom: "15px" } : {}}>
        CONTINUE
      </button>
    </div>
  );
}

export default CalibrateCam;
